import React from 'react'

const SvgComponent = props => (
  <svg width={66} height={66} {...props}>
    <defs>
      <linearGradient
        x1="7.569%"
        y1="110.903%"
        x2="78.899%"
        y2="7.982%"
        id="cli__prefix__a"
      >
        <stop stopColor="#FAC9E3" stopOpacity={0.4} offset="0%" />
        <stop stopColor="#E3486A" offset="100%" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <circle
        cx={33}
        cy={33}
        r={33}
        fill="url(#cli__prefix__a)"
        opacity={0.166}
      />
      <text
        opacity={0.745}
        fontFamily="AvenirNext-Bold, Avenir Next"
        fontSize={26}
        fontWeight="bold"
        fill="#E13F5E"
      >
        <tspan x={13} y={43}>
          {'CLI'}
        </tspan>
      </text>
    </g>
  </svg>
)

export default SvgComponent
